module.exports = __webpack_public_path__ + "static/media/slack.ce9421cd.svg";